export default function groupBy(array, key) {
  return array.reduce((grouped, item) => {
    const groupKey = typeof key === 'function' ? key(item) : item[key];

    if (!grouped[groupKey]) {
      grouped[groupKey] = [];
    }

    grouped[groupKey].push(item);
    return grouped;
  }, {});
}
